var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 85,
    viewBox: "0 0 64 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0349 61.6369H47.9857V23.3631C47.9857 14.3618 40.6245 7.0254 31.5927 7.0254C22.5609 7.0254 15.1996 14.3618 15.1996 23.3631V61.6369H8.15039V23.3631C8.15039 10.4832 18.6691 0 31.5927 0C44.5162 0 55.0349 10.4832 55.0349 23.3631V61.6369Z",
    fill: "#DEE2E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0554 84.9976H4.13039C1.85409 84.9976 0 83.1681 0 80.8812V48.718C0 46.4494 1.85409 44.6016 4.13039 44.6016H59.0554C61.3318 44.6016 63.1858 46.4494 63.1858 48.718V80.8812C63.1858 83.1681 61.3318 84.9976 59.0554 84.9976Z",
    fill: "#DEE2E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8795 59.5503C36.8795 56.6413 34.5114 54.2812 31.5926 54.2812C28.6738 54.2812 26.3057 56.6413 26.3057 59.5503C26.3057 61.947 27.9395 63.9595 30.1423 64.5815V72.4485H33.0244V64.5815C35.2457 63.9595 36.8795 61.947 36.8795 59.5503Z",
    fill: "white"
  })));
}

export default SvgLockIcon;